import React from "react";

import Cotizacion from "../../components/CotizacionAccidentePersonal/CotizacionAccPersonal2";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchObtenerCoberturasAccP, fetchRecuperarCarritoAccP } from "../../redux/actions/aRamoAccidentesPersonales";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";

class ContainerCotizacionAccPersonal2 extends React.Component {
  async componentDidMount() {
    
    //console.log('ingresoPASO2',this.props.listaCoberturasAccP)

    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get("id");

    let idActual = ''

    if (idCarrito !== undefined && idCarrito !== null && idCarrito !== "") {
            idActual = idCarrito
    }else{
      idActual = this.props.datosCarritoAccP.productoAccP.idCarrito
    }

    

    await this.props.recuperarCarrito({ 	empresa:"AIGMETROPOLITANA", idCarrito: idActual });

    const dataPlan = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0]

    //console.log('la daraplan', dataPlan)

    if(dataPlan.subplanes.name===''){

      await this.props.listarCoberturas({
        empresa: "AIGMETROPOLITANA",
        prodCodigoCore: dataPlan.plan.id,
        idCarrito: idActual,
        codigoProductoActual: dataPlan.codigo
      });

    }else{

      await this.props.listarCoberturas({
        empresa:"AIGMETROPOLITANA",
        prodCodigoCore:dataPlan.plan.id,
        subplan: {
                          id: dataPlan.subplanes.id,
                          name: dataPlan.subplanes.name,
                      },
          idCarrito:idActual,
          codigoProductoActual: dataPlan.codigo
      });

    }

  

    if (!this.props.listaCoberturasAccP.listarCoberturasAccPhasError) {
    }
  }
  
  render() {
    
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
              loading={
                this.props.listaCoberturasAccP.listarCoberturasAccPIsLoading
              }
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Cargando datos..."
            >
              {!this.props.listaCoberturasAccP.listarCoberturasAccPIsLoading && this.props.listaCoberturasAccP.coberturasAccP && this.props.listaCoberturasAccP.coberturasAccP[0] && this.props.listaCoberturasAccP.coberturasAccP[0].transaccion && this.props.listaCoberturasAccP.coberturasAccP[0].transaccion === true &&
                    <Cotizacion
                    datosCoberturasAP={
                      this.props.listaCoberturasAccP.coberturasAccP
                    }  
                  />
              }
              

            </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  listaCoberturasAccP: state.listaCoberturasAccP,
  datosCarritoAccP: state.datosCarritoAccP,
  datosRecuperarCarritoAccP: state.datosRecuperarCarritoAccP,
});

const mapDispatchToProps = dispatch => {
  return {
    listarCoberturas: datos => dispatch(fetchObtenerCoberturasAccP(datos)),
    recuperarCarrito: datos => dispatch(fetchRecuperarCarritoAccP(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContainerCotizacionAccPersonal2)
);
